import { Link } from "react-router-dom";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React from "react";
import './styles/Shipping.css'
import HeadlineText from "../../components/TextComponents/HeadlineText";

const ShippingColumn1 = () => {

  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <div className="col-6 row shipping-col shipping-col-1">
      <div className="col-6 m-2">
        <HeadlineText
          styles={{
            marginTop: "2rem",
            textAlign: "left",
            width: 1500,
            position: "relative",
            zIndex: 101, 
          }}
          text={t("shipping & delivery")}
          classNames="text-start"
        ></HeadlineText>
        <div
          style={{
            borderRadius: "0px 110px 0px 110px",
            width: 280,
            height: 303,
            borderWidth: "3px",
            borderStyle: "solid",
            borderColor: theme.COLORS.GREEN.green,
            marginTop: "-100px",
            marginLeft: "439px",
            opacity: 0.25,
            position: "relative",
            zIndex: 98,
          }}
        />
        <div
          style={{
            background: "#ABE1FA",
            borderRadius: "10px 40px 0 40px",
            marginLeft: "410px",
            marginTop: "-95px",
            width: "98px",
            height: "94px",
            opacity: 0.35,
            zIndex: 100,
            boxShadow: "4px 4px 0px #005DFF0F",
          }}
        ></div>
        <div
          style={{
            width: "100%",
            color: theme.COLORS.BLUE.darkBlueGreen,
            fontSize: "2rem",
            marginTop: -40,
          }}
        >
          {t("evrbed Build Time")}
        </div>
        <div
          style={{
            width: "140%",
            color: theme.COLORS.BLUE.darkBlueGreen,
            marginTop: "2vh",
            fontSize: "1.3rem",
          }}
        >
          {t(
            "Each evrbed is custom build to your exact specifications in our manufacturing facility in Calgary, Alberta."
          )}
        </div>
        <div
          style={{
            width: "145%",
            color: theme.COLORS.BLUE.darkBlueGreen,
            fontSize: "1.3rem",
            marginTop: "2vh",
          }}
        >
          {t(
            "After we receive your order a Sleep Expert will review it and will personally contact you with any questions and in some cases to futher discuss your inputs."
          )}
        </div>
        <div
          style={{
            width: "130%",
            color: theme.COLORS.BLUE.darkBlueGreen,
            fontSize: "1.3rem",
            marginTop: "2vh",
          }}
        >
          {t(
            "Your evrbed will begin production and will be complete and ready for shipping in 3-5 business days."
          )}
        </div>
        <div
          className="justify-content-md-center"
          style={{ marginTop: "3vh" }}
        ></div>
      </div>
    </div>
  );
};

export default ShippingColumn1;
